<template>
  <div v-if="loaded" id="payment_step" class="form-step-container">
    <!-- תגית השלב והכותרת -->
    <div class="step-badge" v-html="words.step + ' ' + step"></div>
    <h1 class="main-title" v-html="words.payment_info"></h1>

    <div class="form_steps">
      <!-- כרטיסייה המכילה את ה-iframe של התשלום -->
      <div class="card-box iframe-card">
        <template v-if="paymentId && paymentId > 0">
          <iframe 
            :src="paymentUrl" 
            class="payment-iframe"
            title="Payment Frame"
          ></iframe>
        </template>
      </div>

      <!-- סרגל כפתור חזרה בתחתית -->
      <div class="action-footer">
        <button 
          type="button" 
          class="btn-back" 
          tabindex="0" 
          @click="$emit('returnStep')"
        >
          ➔ <span v-html="words.return_step"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      isLoading: false,
      loaded: false,
      paymentId: 0,
      paymentUrl: '',
      credit: {
        number: '',
        id: '',
        expire: '',
        cvv: ''
      }
    }
  },
  computed: {
    words() {
      return this.$store.state.words || {}
    }
  },
  mounted() {
    this.getPayment()
  },
  methods: {
    getPayment() {
      this.$store.commit('setIsLoading', { isLoading: true })
      this.api({ action: 'create_payment' }, (data) => {
        this.paymentId = data.data.payment_id
        this.paymentUrl = data.data.payment_link
        this.$store.commit('setIsLoading', { isLoading: false })
        this.loaded = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$purple-primary: #6B11D8;
$purple-light: #F5EFFF;
$purple-hover: #550bb1;
$bg-light: #F8F9FD;
$text-dark: #2B2635;
$text-muted: #718096;
$border-color: #E2E8F0;
$radius: 16px;

.form-step-container {
  direction: rtl;
  text-align: right;
  font-family: inherit;

  /* התאמה לגובה המסך ומניעת גלילה מיותרת */
  max-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;

 .step-badge {
  display: block;
  width: 100%;               
  box-sizing: border-box;
  background: #F5EFFF;       
  color: #6B11D8;           
  font-size: 13px;
  font-weight: 700;
  padding: 8px 16px;
  border-radius: 20px;
  margin-bottom: 12px;
  text-align: right;       
}

  .main-title {
    font-size: 22px;
    font-weight: 800;
    color: $text-dark;
    margin: 0 0 12px 0;
  }

  .form_steps {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1;
    justify-content: space-between;
  }

  /* כרטיסיית המסגרת של התשלום */
  .card-box {
    background: #ffffff;
    border: 1px solid $border-color;
    border-radius: $radius;
    padding: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);

    &.iframe-card {
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
    }
  }

  /* עיצוב ה-iframe */
  .payment-iframe {
    border: none;
    width: 100%;
    height: 480px;
    max-height: 60vh;
    border-radius: 10px;
    background-color: #ffffff;
  }

  /* סרגל כפתור חזרה בתחתית */
  .action-footer {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: auto;
    padding-top: 10px;

    .btn-back {
      background: transparent;
      border: none;
      color: $text-muted;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      padding: 8px 12px;
      border-radius: 20px;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      transition: all 0.2s ease;

      &:hover {
        color: $purple-primary;
        background-color: $purple-light;
      }
    }
  }
}
</style>